module.exports = __webpack_public_path__ + "static/autocad-b5ca198f3886b1c0ef948c39d84279bd.png";